export function buildWhatsappLink(number, message) {
  const cleanNumber = (number || "").replace(/[^0-9]/g, "");
  const text = encodeURIComponent(message);
  return `https://wa.me/${cleanNumber}?text=${text}`;
}

export function dressInquiryMessage(dress) {
  const label = dress ? `${dress.name} (Kleid ${dress.number})` : "ein Kleid";
  return `Hallo 10/10 Kleiderverleih, ich interessiere mich für ${label}. Ist das Kleid am [Datum eintragen] verfügbar?`;
}

export function genericInquiryMessage() {
  return "Hallo 10/10 Kleiderverleih, ich interessiere mich für eure Kleider und würde gerne eine Anprobe vereinbaren.";
}
